import TicketPriorities from './TicketPriorities';
import TicketPrioritiesProvider from './TicketPrioritiesContext';

let Index = () => {
    return (
        <TicketPrioritiesProvider>
            <TicketPriorities />
        </TicketPrioritiesProvider>
    )
}

export default Index;